import React from "react";

const ProjectManagementKanbanView = () => {
  return <div>ProjectManagementKanbanView</div>;
};

export default ProjectManagementKanbanView;
